module.exports = __webpack_public_path__ + "img/account-m2.63c5b9fc.png";